export default "__VITE_ASSET__DX8CbG8n__"